import { render, staticRenderFns } from "./visualizadorProcesso.vue?vue&type=template&id=4f8b08bf&scoped=true"
import script from "./visualizadorProcesso.vue?vue&type=script&lang=js"
export * from "./visualizadorProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b08bf",
  null
  
)

export default component.exports